function getFirstArrayVal(arr) {
    return arr[0];
}

function getLastArrayVal(arr) {
    return arr[arr.length - 1];
}

function getNextArrayVal(arr, val) {
    const index = arr.indexOf(val);

    if (index === -1 || index >= arr.length)
        return null;

    return arr[index + 1];
}

function getPrevArrayVal(arr, val) {
    const index = arr.indexOf(val);

    if (index <= 0)
        return null;

    return arr[index - 1];
}

export { getFirstArrayVal, getLastArrayVal, getNextArrayVal, getPrevArrayVal };